// Copyright 2024 - MinIO, Inc. All rights reserved.

import React, { Fragment } from "react";
import {
  ActionLink,
  Box,
  Button,
  FormLayout,
  InputBox,
  ProgressBar,
} from "mds";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setJwt, setSetupPlan } from "./setupSlice";
import { validateLicense } from "./setupThunks";
import SetupJoinForm from "./SetupJoinForm";

const SetupStep1 = () => {
  const dispatch = useAppDispatch();

  const status = useAppSelector((state) => state.setup.status);
  const setupPlan = useAppSelector((state) => state.setup.setupPlan);
  const jwt = useAppSelector((state) => state.setup.jwt);
  const jwtError = useAppSelector((state) => state.setup.jwtError);

  return (
    <Fragment>
      <Box sx={{ marginBottom: 16 }}>
        Welcome! To activate Enterprise Object Store, you need to enter your
        license. If this License is provided by a remote Control Plane, you can
        configure the Join parameters.
      </Box>
      <Box sx={{ width: "100%" }}>
        {setupPlan === "register" && (
          <FormLayout withBorders={false} containerPadding={false}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(validateLicense());
              }}
            >
              <InputBox
                id={"license"}
                placeholder="License"
                value={jwt}
                error={jwtError}
                onChange={(e) => dispatch(setJwt(e.target.value))}
                disabled={status === "loading"}
              />
              {status === "loading" && <ProgressBar />}
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  id={"register"}
                  type={"button"}
                  onClick={() => dispatch(validateLicense())}
                  variant={"callAction"}
                  disabled={jwt.trim() === "" || status === "loading"}
                >
                  {status === "loading" ? "Validating..." : "Continue"}
                </Button>
              </Box>
            </form>
          </FormLayout>
        )}
        {setupPlan === "join" && <SetupJoinForm />}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <Box sx={{ textAlign: "center" }}>or</Box>
        <Box sx={{ textAlign: "center" }}>
          {setupPlan === "register" ? (
            <ActionLink onClick={() => dispatch(setSetupPlan("join"))}>
              Join Remote Control Plane
            </ActionLink>
          ) : (
            <ActionLink onClick={() => dispatch(setSetupPlan("register"))}>
              Register License
            </ActionLink>
          )}
        </Box>
      </Box>
    </Fragment>
  );
};

export default SetupStep1;
